import React, { useState } from 'react';
import FormClientes from '../../../components/ui/Asesor/ClientesComponents/FormClientes';

const ClientesUI = () => {
  const [showForm, setShowForm] = useState(false);

  const handleClientAdded = (newClientResponse) => {
    console.log('Cliente agregado exitosamente:', newClientResponse);
    setShowForm(false);
  };

  const toggleForm = () => {
    setShowForm(!showForm);
    if (!showForm) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="space-y-6 p-4">
      <section className="ui-card relative overflow-hidden px-6 py-7 md:px-8">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_88%_10%,rgba(217,44,52,0.12),transparent_38%)]" />
        <div className="relative">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-red-600">Gestión comercial</p>
          <h1 className="mt-2 text-2xl font-semibold text-slate-900 md:text-3xl">Registro de clientes</h1>
          <p className="mt-2 text-sm text-slate-600">
            Registra nuevos clientes con un formulario unificado y campos validados.
          </p>
        </div>
      </section>

      <section className="ui-card p-4">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <h2 className="text-lg font-semibold text-slate-900">Operaciones de cliente</h2>
          <button
            onClick={toggleForm}
            className={`${showForm ? 'bg-slate-600 hover:bg-slate-700' : 'bg-red-600 hover:bg-red-700'} inline-flex w-full items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold text-white transition sm:w-auto`}
          >
            {showForm ? (
              <>
                <svg xmlns="http://www.w3.org/2000/svg" className="mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                CERRAR FORMULARIO
              </>
            ) : (
              <>
                <svg xmlns="http://www.w3.org/2000/svg" className="mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                AGREGAR NUEVO CLIENTE
              </>
            )}
          </button>
        </div>
      </section>

      {showForm ? (
        <section className="ui-card overflow-hidden">
          <div className="flex items-center justify-between border-b border-slate-200 px-4 py-3">
            <h3 className="text-base font-semibold text-slate-900">AGREGAR NUEVO CLIENTE</h3>
            <button
              onClick={() => setShowForm(false)}
              className="text-slate-500 transition hover:text-slate-700"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="p-4">
            <FormClientes
              onClientAdded={handleClientAdded}
              onCancel={() => setShowForm(false)}
            />
          </div>
        </section>
      ) : (
        <section className="ui-card p-12 text-center">
          <div className="flex flex-col items-center">
            <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-50 text-red-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-slate-900">Registrar cliente</h3>
            <p className="mt-2 max-w-md text-sm text-slate-600">
              Usa el botón "Agregar nuevo cliente" para abrir el formulario y completar el registro.
            </p>
          </div>
        </section>
      )}
    </div>
  );
};

export default ClientesUI;
